import React, { useState } from "react";
import {
  Row,
  Col,
  Label,
  Input,
  Spinner
} from "reactstrap";
import { withTranslation } from "react-i18next";

import axiosInstance from 'utils/axiosInstance';

import { TransitionGroup, CSSTransition } from 'react-transition-group';

const ConditionsList = ({ 
  t,
  showActivationConditions,
  setShowActivationConditions,
  showAffectedAttributes,
  setShowAffectedAttributes,
  questionSetAttributes,
  setQuestionSetAttributes,
  activeTab,
  fetchInfoData
}) => {

  const [isToggleAttributeLoading, setIsToggleAttributeLoading] = useState(false);
  const [toggleAttributeName, setToggleAttributeName] = useState("");
  const handleToggleAttribute = async (attributeName) => {
    const updatedAttributes = questionSetAttributes.map((attr) => 
      attr.name === attributeName ? { ...attr, inUserAttributes: !attr.inUserAttributes } : attr
    );
    setIsToggleAttributeLoading(true);
    setToggleAttributeName(attributeName);
    setQuestionSetAttributes(updatedAttributes); // Update local display first

    try {
      await axiosInstance.post(`/knovia/infoQuestionSet/${activeTab}/testUserAttributes`, {
        attributeName,
        isAdding: !questionSetAttributes.find(attr => attr.name === attributeName).inUserAttributes,
      });
      await fetchInfoData();
      setIsToggleAttributeLoading(false);
      setToggleAttributeName("");
      console.log("Updated user attributes successfully");
    } catch (error) {
      console.error("Error updating user attributes", error);
      setIsToggleAttributeLoading(false);
      setToggleAttributeName("");
      alert("更新失敗，請稍後再試。");
      // (Optional) You could revert the local state if server update failed
    }
  };

  return (
    <Row className="mb-4 mb-lg-3 mt-lg-1">
      <Col xs={12} className="mb-4"
        style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}
      >
        <div style={{ marginTop: "1rem", marginRight: "1.2rem" }}>
          <Input
            id={`show-activation-conditions`}
            className="me-2 attribute-checkbox"
            type="checkbox"
            checked={showActivationConditions}
            onChange={() => {setShowActivationConditions(!showActivationConditions)}}
          />
          <Label
            htmlFor={`show-activation-conditions`}
            className="attribute-label"
            style={{ margin: "0" }}
          >
            顯示啟動條件
          </Label>
        </div>
        <div style={{ marginTop: "0.3rem", marginRight: "1.2rem" }}>
          <Input
            id={`show-affected-attributes`}
            className="me-2 attribute-checkbox"
            type="checkbox"
            checked={showAffectedAttributes}
            onChange={() => {setShowAffectedAttributes(!showAffectedAttributes)}}
          />
          <Label
            htmlFor={`show-affected-attributes`}
            className="attribute-label"
            style={{ margin: "0" }}
          >
            顯示影響屬性
          </Label>
        </div>
      </Col>
      <Col xs={12} md={6} xl={5}>
        {questionSetAttributes.map((attr, index) => (
          <div 
            key={attr.name} 
            className="attribute-toggle-wrapper"
            style={{
              marginBottom: "0.2rem",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Input
              id={`attribute-${index}`}
              className="me-2 attribute-checkbox"
              type="checkbox"
              checked={attr.inUserAttributes}
              onChange={() => handleToggleAttribute(attr.name)}
            />
            <Label
              htmlFor={`attribute-${index}`}
              className="attribute-label"
              style={{
                margin: "0",
                color: attr.inUserAttributes ? "#2e9f6f" : "#9b9b9b",
              }}
            >
              {attr.name}
              {toggleAttributeName && toggleAttributeName===attr.name && (
                <Spinner
                  style={{
                    color: attr.inUserAttributes ? "#5cb48e" : "#9b9b9b",
                    height: "13px",
                    width: "13px",
                    margin: "0",
                    marginLeft: "5px",
                    borderWidth: "thin"
                  }}
                />
              )}
            </Label>
          </div>
        ))}
      </Col>
    </Row>
  );
};

export default withTranslation()(ConditionsList);
